import React from 'react';
import styled from 'styled-components';
import { miniCaption, font } from '../../../theme/typography';
import { cinnabar300 } from '../../../theme/colors';


export const ToolTipContentStyle = styled.ul`
    margin:0;
    padding:0;
    font-weight: 500;
    list-style:none;
    font-size: ${font.base};
    line-height:18px;
    li {
        &:before{
            content:'.';
            font-size:${font.mediumSmall};
            position: absolute;
            left:0;
            top:3px;
        }
        ${miniCaption.regular}
        position:relative;
        padding:10px 10px 5px 15px;
    }
`;

const PasswordHint = ({addConditionRule}) => {
    return (
        <ToolTipContentStyle>
            Password Requirements
            <li>The minimum password length is 8 characters.</li>
            <li>Password must contain at least 1 uppercase character.</li>
            <li>Password must contain at least 1 digit.</li>
            <li>Password must contain at least 1 special character.</li>
            {addConditionRule && <li>{addConditionRule}</li>}
        </ToolTipContentStyle>
    )
}

export default PasswordHint;